module.exports = __webpack_public_path__ + "c60f1b61d520cb564f8cdef5869db594.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/history/fi-2010.png
// module id = 385
// module chunks = 0